export default "__VITE_ASSET__BPEfEL1B__"